import { PaisEnum } from '@app/core/models';
import { RoleFn } from './role';

const role: RoleFn = ({ usuario_ativo }) =>
  usuario_ativo?.pais_id === PaisEnum.Argentina &&
  ['R', 'F', 'L'].includes(usuario_ativo?.tipoResponsavel) &&
  usuario_ativo?.escola_externa !== 1;
export default role;
